/**
 * @generated SignedSource<<ac548052e45a082fbbd04ae41efb85b9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type DeleteIntegrationInput = {
  id: any;
};
export type FireHydrantIntegrationDeleteIntegrationMutation$variables = {
  input: DeleteIntegrationInput;
};
export type FireHydrantIntegrationDeleteIntegrationMutation$data = {
  readonly deleteIntegration: {
    readonly error: string | null | undefined;
    readonly success: boolean;
  };
};
export type FireHydrantIntegrationDeleteIntegrationMutation = {
  response: FireHydrantIntegrationDeleteIntegrationMutation$data;
  variables: FireHydrantIntegrationDeleteIntegrationMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DeleteIntegrationPayload",
    "kind": "LinkedField",
    "name": "deleteIntegration",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "success",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "error",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "FireHydrantIntegrationDeleteIntegrationMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "FireHydrantIntegrationDeleteIntegrationMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "c9af0d183a6c11731aff468564150b97",
    "id": null,
    "metadata": {},
    "name": "FireHydrantIntegrationDeleteIntegrationMutation",
    "operationKind": "mutation",
    "text": "mutation FireHydrantIntegrationDeleteIntegrationMutation(\n  $input: DeleteIntegrationInput!\n) {\n  deleteIntegration(input: $input) {\n    success\n    error\n  }\n}\n"
  }
};
})();

(node as any).hash = "1217b92afd133c0bfd7a7e477401b2b5";

export default node;
